var map = {
	"./Bootstrap.webp": 7988,
	"./CSS.webp": 8586,
	"./Firebase.webp": 4562,
	"./HTML.webp": 8687,
	"./JavaScript.webp": 1448,
	"./MySQL.webp": 9214,
	"./NextJS.webp": 2840,
	"./React Router.webp": 2607,
	"./React.webp": 9075,
	"./Redux.webp": 9381,
	"./Sass.webp": 1111,
	"./Tailwind CSS.webp": 3092,
	"./Testing Library.webp": 6162,
	"./TypeScript.webp": 9384,
	"./cv.webp": 5297,
	"./cv_ok.webp": 4427,
	"./deploy.webp": 5397,
	"./github.webp": 5834,
	"./github_2.webp": 7114,
	"./linkedin.webp": 9119,
	"./music/applemusic.webp": 5454,
	"./music/spotify.webp": 4632,
	"./music/ytmusic.webp": 1600,
	"./void.webp": 9676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8466;